import { useGetApiV1GroupsByGroupIdMembersQuery } from '../../api'
import { GroupMemberRoleFilter } from '@wellesley/openapi'

type HookProps = {
  groupId?: string
  role?: GroupMemberRoleFilter
  skip?: boolean
}

const useGroupMembers = ({ groupId, role, skip }: HookProps) => {
  const {
    data: members,
    isLoading,
    refetch,
  } = useGetApiV1GroupsByGroupIdMembersQuery(
    {
      groupId: groupId!,
      role,
    },
    {
      skip: skip ?? !groupId,
    },
  )

  return {
    members,
    isLoading,
    refetch,
  }
}

export default useGroupMembers
